/**
 * Represents the type of an [[Item]] entity.
 */
export var ItemType;
(function (ItemType) {
    /**
     * A normal item that can be purchased directly or as a modifier.
     */
    ItemType["Normal"] = "Normal";
    /**
     * An item with options that can be purchased.
     */
    ItemType["ParentSales"] = "ParentSales";
    /**
     * A package item that can be purchased containing one or more items.
     */
    ItemType["Package"] = "Package";
    /**
     * An item that is made using one or more other items.
     *
     * @remarks
     * An item will be of type [[Recipe]] if it has the type 'Made at sale time (Recipe)' in Back Office and
     * has at least one non 'Component' type item in its recipe.
     */
    ItemType["Recipe"] = "Recipe";
})(ItemType || (ItemType = {}));
//# sourceMappingURL=item-type.js.map